import { Outlet, createRootRoute } from '@tanstack/react-router';

export const rotaRaiz = createRootRoute({
  component: () => (
    <div className="min-h-dvh font-sans antialiased">
      <Outlet />
    </div>
  ),
});
